import { createElement } from 'react'

//Components
import CASLanguage from 'components/xis/CASLanguage'

export default (node:any, params:any, options:any) => {
  return createElement(
    CASLanguage as React.FunctionComponent
  )
}